export const ERROR_CATEGORIES = {
  API: 'api_error',
  UNKNOWN: 'unknown_error'
}

export const ERROR_TYPES = {
  API_NOT_FOUND: 'api_not_found', // 404
  API_SERVER_ERROR: 'api_server_error', // 5xx
  API_CLIENT_ERROR: 'api_client_error', // 4xx
  API_AUTH_ERROR: 'api_auth_error', // 401/403
  UNKNOWN: 'unknown_error'
}

export function identifyErrorCategory(error) {
  if (error && (error.response || error.status)) {
    return ERROR_CATEGORIES.API
  }

  return ERROR_CATEGORIES.UNKNOWN
}

export function identifyApiErrorType(error) {
  if (!error) return ERROR_TYPES.UNKNOWN

  if (error.response || error.status) {
    const status = error.response ? error.response.status : error.status

    if (status === 401 || status === 403) return ERROR_TYPES.API_AUTH_ERROR
    if (status === 404) return ERROR_TYPES.API_NOT_FOUND
    if (status >= 500) return ERROR_TYPES.API_SERVER_ERROR
    if (status >= 400) return ERROR_TYPES.API_CLIENT_ERROR
  }

  return ERROR_TYPES.UNKNOWN
}
